(() => {
  const widget = document.querySelector("[data-roughie-radio]");
  if (!widget) return;

  const button = widget.querySelector("[data-radio-toggle]");
  const stateLabel = widget.querySelector("[data-radio-state]");
  const playerHost = widget.querySelector(".roughie-radio-player");
  const videoId = widget.dataset.videoId;
  const startAt = Number(widget.dataset.startAt || "0");
  let player = null;
  let playerReady = false;
  let isPlaying = false;
  let wantsToPlay = true;
  let userHasInteracted = false;
  let youtubeApiPromise = null;
  let scrollFrame = null;

  function updateRadioScrollPath() {
    const viewportHeight = window.innerHeight || 1;
    const availableScroll = Math.max(1, document.documentElement.scrollHeight - viewportHeight);
    const scrollRange = Math.min(720, Math.max(360, availableScroll));
    const travelDistance = Math.min(420, Math.max(240, viewportHeight * 0.54));
    const scrollPosition = window.scrollY || document.documentElement.scrollTop || 0;
    const progress = Math.min(1, Math.max(0, scrollPosition / scrollRange));

    widget.style.setProperty("--roughie-radio-path-y", `${(travelDistance * progress).toFixed(2)}px`);
  }

  function scheduleRadioScrollPath() {
    if (scrollFrame !== null) return;
    scrollFrame = window.requestAnimationFrame(() => {
      scrollFrame = null;
      updateRadioScrollPath();
    });
  }

  window.addEventListener("scroll", scheduleRadioScrollPath, { passive: true });
  window.addEventListener("resize", scheduleRadioScrollPath, { passive: true });
  updateRadioScrollPath();

  function updateRadioState(nextIsPlaying) {
    isPlaying = nextIsPlaying;
    button.classList.toggle("is-playing", nextIsPlaying);
    stateLabel.textContent = nextIsPlaying ? "Pause" : "Play";
    button.setAttribute("aria-label", (nextIsPlaying ? "Pause" : "Play") + " Roughie Radio");
  }

  function loadYouTubeApi() {
    if (window.YT?.Player) return Promise.resolve();
    if (youtubeApiPromise) return youtubeApiPromise;

    youtubeApiPromise = new Promise((resolve) => {
      const previousCallback = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => {
        if (typeof previousCallback === "function") previousCallback();
        resolve();
      };
      const script = document.createElement("script");
      script.id = "roughie-youtube-api";
      script.src = "https://www.youtube.com/iframe_api";
      script.async = true;
      document.head.appendChild(script);
    });

    return youtubeApiPromise;
  }

  function startFromUserGesture() {
    userHasInteracted = true;
    wantsToPlay = true;
    if (!playerReady) return;
    player.unMute();
    player.setVolume(100);
    player.playVideo();
  }

  function createPlayer() {
    loadYouTubeApi().then(() => {
      player = new window.YT.Player(playerHost, {
        height: "1",
        width: "1",
        videoId,
        playerVars: {
          autoplay: 1,
          controls: 0,
          loop: 1,
          modestbranding: 1,
          playsinline: 1,
          playlist: videoId,
          rel: 0,
          start: startAt
        },
        events: {
          onReady: () => {
            playerReady = true;
            if (wantsToPlay) {
              if (userHasInteracted) {
                player.unMute();
                player.setVolume(100);
              }
              player.playVideo();
            }
          },
          onAutoplayBlocked: () => {
            if (!userHasInteracted) {
              player.mute();
              player.playVideo();
            } else {
              updateRadioState(false);
            }
          },
          onStateChange: (event) => {
            updateRadioState(event.data === window.YT.PlayerState.PLAYING);
          }
        }
      });
    });
  }

  function pauseRadio() {
    wantsToPlay = false;
    if (playerReady) player.pauseVideo();
    updateRadioState(false);
  }

  button.addEventListener("click", (event) => {
    event.stopPropagation();
    if (!userHasInteracted) {
      startFromUserGesture();
    } else if (wantsToPlay) {
      pauseRadio();
    } else {
      startFromUserGesture();
    }
  });

  document.addEventListener("pointerdown", (event) => {
    if (!event.target.closest("[data-radio-toggle]")) startFromUserGesture();
  }, { once: true, passive: true });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Tab" && !event.target.closest("[data-radio-toggle]")) startFromUserGesture();
  }, { once: true });

  updateRadioState(false);
  createPlayer();
})();